// extracted by mini-css-extract-plugin
export var chip = "_dl-0";
export var filterDropdown = "_dl-5";
export var filterItem = "_dl-6";
export var icon = "_dl-1";
export var removeButton = "_dl-3";
export var removeIcon = "_dl-4";
export var separator = "_dl-2";